import { TMapLocker } from "../types";
import getClusterIcon from "./getClusterIcon";
import { getLockerIcon, getSelectedLockerIcon } from "./getMapIcon";

type TSetupParams = {
  lockers: TMapLocker[];
  onMarkerClick: (evt: any) => void;
  selectedLockerId?: string;
};

type TSetupReturn = {
  layer: H.map.layer.ObjectLayer;
  lockerMarkers: H.map.Marker[];
};

const setupClusterLayer = ({ lockers, onMarkerClick, selectedLockerId }: TSetupParams): TSetupReturn => {
  const dataPoints = lockers.map((item) => new H.clustering.DataPoint(item.lat, item.lng, undefined, item));

  const clusteredDataProvider = new H.clustering.Provider(dataPoints, {
    clusteringOptions: {
      eps: 32,
      minWeight: 2,
    },
  });

  const lockerMarkers: H.map.Marker[] = [];

  clusteredDataProvider.setTheme({
    getClusterPresentation: (cluster) => {
      const weight = cluster.getWeight();

      const icon = getClusterIcon(weight);

      const marker = new H.map.Marker(cluster.getPosition(), {
        icon,
        min: cluster.getMinZoom(),
        max: cluster.getMaxZoom(),
      });
      marker.setData(cluster);

      return marker;
    },
    getNoisePresentation: (noisePoint) => {
      const lockerData = noisePoint.getData();
      const noiseMarker = new H.map.Marker(noisePoint.getPosition(), {
        icon: selectedLockerId === lockerData.id ? getSelectedLockerIcon() : getLockerIcon(),
        min: noisePoint.getMinZoom(),
      });

      noiseMarker.setData(noisePoint);

      lockerMarkers.push(noiseMarker);
      return noiseMarker;
    },
  });

  clusteredDataProvider.addEventListener("tap", onMarkerClick);

  const layer = new H.map.layer.ObjectLayer(clusteredDataProvider);

  return { layer, lockerMarkers };
};
export default setupClusterLayer;
